import { useEffect, useMemo, useRef } from "react";
import { ImagePlus, X } from "lucide-react";
import { Label } from "../ui/label";

export function LogoUpload({ file, onChange }) {
  const inputRef = useRef(null);
  const preview = useMemo(() => (file ? URL.createObjectURL(file) : null), [file]);
  useEffect(() => () => preview && URL.revokeObjectURL(preview), [preview]);

  return (
    <div data-testid="logo-upload">
      <Label className="text-white/70 text-xs">Brand logo (optional) - keeps the label on the product accurate</Label>
      <div className="flex items-center gap-3 mt-1">
        {preview ? (
          <div className="relative w-16 h-16 rounded-lg bg-white/5 border border-white/10 p-1">
            <img src={preview} alt="Brand logo" className="w-full h-full object-contain" data-testid="logo-preview" />
            <button type="button" data-testid="logo-remove-btn" onClick={() => onChange(null)}
              className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-red-500 flex items-center justify-center">
              <X className="w-3 h-3 text-white" />
            </button>
          </div>
        ) : (
          <button type="button" data-testid="logo-upload-btn" onClick={() => inputRef.current?.click()}
            className="flex items-center gap-2 px-3 py-2 rounded-lg border border-dashed border-white/20 text-white/60 text-xs hover:border-cyan-400 hover:text-cyan-300 transition-colors">
            <ImagePlus className="w-4 h-4" /> Upload logo
          </button>
        )}
        <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" data-testid="logo-file-input"
          onChange={(e) => { onChange(e.target.files?.[0] || null); e.target.value = ""; }} />
      </div>
    </div>
  );
}
